import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import NosotrosPage from "./pages/NosotrosPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/nosotros" element={<NosotrosPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#141414",
                        border: "1px solid #262626",
                        color: "#fff",
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
